import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
// eslint-disable-next-line import/prefer-default-export
export var getQueryParams = function getQueryParams() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var search = location.search;
  if (!search) return {};
  return search.slice(1).split('&').reduce(function (prev, cur) {
    var _cur$split = cur.split('='),
        _cur$split2 = _slicedToArray(_cur$split, 2),
        key = _cur$split2[0],
        value = _cur$split2[1];

    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, decodeURIComponent(value)));
  }, {});
};